import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, AssetMovement, IAssetMovementsByUser, AssetType } from "../../../logic/api";
import styles from "../styles";
import MovementListItem from "../../../components/lists/listItems/MovementListItem/MovementListItem";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import usePaths from "../../../utility/paths";
import AssetMovementRow from "./condensedLayout/assetMovement/AssetMovementRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";

const AssetMovementsByUser: React.FunctionComponent<{
  locationId: number;
  type: AssetType;
  isCondensedView?: boolean;
}> = (props) => {
  const paths = usePaths();
  const { t } = useTranslation();
  const history = useHistory();
  const [params, setParams] = useState<IAssetMovementsByUser>({
    locationId: props.locationId,
    type: props.type,
  });
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);


  useEffect(() => {
    if (props.locationId != params.locationId) {
      setParams({
        ...params, locationId: props.locationId, type: props.type
      });
    }
  }, [props.locationId, props.type]);

  const handleGoToBooking = (bookingId: number) => {
    if (isOpenLinksInNewTab) {
      window.open(paths.booking(bookingId), "_blank");
    } else {
      history.push(paths.booking(bookingId));
    }
  }

  const columnHeaders = [t("locations.direction"), t("booking.labels.ref"), "", t("locations.vehicleReg"), "", t("booking.cards.vehicle"), t("booking.labels.vehicleLastMovementBy"), t("booking.labels.vehicleLastMovement"), ""];

  columnHeaders[2] = (props.type === AssetType.vehicle) ? t("booking.labels.vehicleLocation") : t("booking.labels.keyLocation");

  return <div>
    {props.isCondensedView ?
      <PagedDataView<IAssetMovementsByUser, AssetMovement>
        apiHook={api.hooks.assetMovement.getMovementsByUser}
        parameters={params}
        header={() => <HeaderRow columnHeaders={columnHeaders} />}
        isTable
        animate={false}
        renderItem={(item, index) => {
          return <AssetMovementRow assetMovement={item} movementCategory={props.type} rowIndex={index} onClick={() => handleGoToBooking(item.booking.id)} />
        }}
      >
        <div style={styles.noData}>
          {t("input.validations.noMovements")}
        </div>
      </PagedDataView>
      :
      (
        <PagedDataView<IAssetMovementsByUser, AssetMovement>
          apiHook={api.hooks.assetMovement.getMovementsByUser}
          parameters={params}
          animate={false}
          renderItem={(item) => {
            return <MovementListItem item={item} onClick={() => handleGoToBooking(item.booking.id)} />
          }}
        ><div style={styles.noData}>
            {t("input.validations.noMovements")}
          </div>
        </PagedDataView>
      )
    }
  </div>
};

AssetMovementsByUser.propTypes = {
  locationId: propTypes.number.isRequired,
  type: propTypes.any.isRequired,

}

export default AssetMovementsByUser;
